export enum SubscriptionGroupField {
  PRODUCT = 'PRODUCT',
  PRODUCT_PROVIDER = 'PRODUCT_PROVIDER',
  CUSTOMER = 'CUSTOMER',
  TRUSTEE = 'TRUSTEE',
}
